import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getItem } from "../../../../../Store/Store/Item/Item";
import { getParty } from "../../../../../Store/Store/Party/Party";
import { getProject } from "../../../../../Store/Store/Project/Project";
import { getGenMaster } from "../../../../../Store/Store/GenralMaster/GenMaster";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import PurReceiveFields from "./components/PurReceiveFields";
import { getTransport } from "../../../../../Store/Store/StoreMaster/Transport/Transport";
import { getPoNo } from "../../../../../Store/prosafe/proTransaction/PurReceive/getPoNo";
import Footer from "../../../Include/Footer";
import PurReceiveItems from "./components/PurReceiveItems";
import PurReceiveTable from "./components/PurReceiveTable";
import { getViewReceiveItems } from "../../../../../Store/prosafe/proTransaction/PurReceive/getViewReceiveItems";
import toast from "react-hot-toast";
import axios from "axios";
import { V_URL } from "../../../../../BaseUrl";
import Swal from "sweetalert2";
import TaxSummary from "../../../../../Components/Transaction/TaxSummary";

const DEFAULT_PO_TERMS = `1. Materials should be Supplied for the Specifications and Quality standards.<br />2. Delivery Within The Distribution Time is Mandatory.<br />3. Any Defect of Materials Will be returned.<br />4. Supplier Must Submit a Proper Tax Invoice With GST Details.<br />5. Po Number Must be Mentioned on All Invoices and Delivery Challan. <br />
<br />Thanks for doing business with us.<br />
`;

const initialForm = {
  trans_date: moment(Date.now()).format("YYYY-MM-DD"),
  master_id: "",
  project_id: "",
  manual_pro_no: "",
  party_id: "",
  receive_date: moment(Date.now()).format("YYYY-MM-DD"),
  bill_no: "",
  transport_id: "",
  transport_date: "",
  lr_no: "",
  lr_date: "",
  challan_no: "",
  payment_date: "",
  payment_days: "",
  pdf: "",
  vehical_no: "",
  driver_name: "",
  remarks: "",
  loading_amount: "",
  freight_amount: "",
  total_amount: 0,
  total_quantity: 0,
  isExisting: false
};

const initialItemState = {
  item_id: '',
  // item_no: '',
  // item_length: '',
  // item_width: '',
  // item_weight: '',
  // item_radius: '',
  // item_thickness: '',
  // assembly_weight: '',
  // assembly_surface_area: '',
  // heat_no: '',
  // plat_no: '', 
  // tc_no: '',
  item_name: '',
  unit: '',
  category: '',
  quantity: "",
  rate: '',
  amount: '0.00',
  discount: "0",
  discount_amount: "0.00",
  sp_discount: "0",
  sp_discount_amount: "0.00",
  taxable_amount: "0.00",
  gst: '0',
  gst_amount: "0.00",
  total_amount: "0.00",
  remarks: '',
  isAuto: false,
  from_id: null,
  detail_id: null,
  original_qty: 0,
};

const ManagePurReceive = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state: data } = useLocation();
  const [disable, setDisable] = useState(false);
  const [error, setError] = useState({});
  const [form, setForm] = useState(initialForm);
  const [itemsArr, setItemsArr] = useState([{ ...initialItemState }]);
  const [itemErrors, setItemErrors] = useState([{}]);
  const [canAddMoreItems, setCanAddMoreItems] = useState(false);
  const [termsCondition, setTermsCondition] = useState(DEFAULT_PO_TERMS || "");
  const [taxSummary, setTaxSummary] = useState({
    subtotal: 0,
    cgst: 0,
    sgst: 0,
    igst: 0,
    taxAmount: 0,
    roundOff: 0,
    total: 0,
    loading_amount: 0,
    freight_amount: 0,
  });

  const itemDataStore = useSelector((state) => state.getItem?.user?.data) || [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (error[name]) {
      setError((prev) => {
        const newError = { ...prev };
        delete newError[name];
        return newError;
      });
    }
  };

  const handlePdf = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;
    const fileType = file.type;
    const allowedTypes = {
      pdf: ["application/pdf"],
      image: ["image/png", "image/jpeg", "image/jpg", "image/webp"],
    };
    const fileCategory = Object.keys(allowedTypes).find((type) =>
      allowedTypes[type].includes(fileType)
    );
    if (!fileCategory) {
      toast.error("Invalid file type. Only images and PDFs are allowed.");
      return;
    }
    const uploadUrl = `${V_URL}/upload-image`;
    const formData = new FormData();
    formData.append("image", file);
    axios
      .post(uploadUrl, formData)
      .then((res) => {
        if (res.data.success) {
          const uploaded = res.data.data?.[fileCategory];
          setForm((prev) => ({ ...prev, pdf: uploaded }));
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.response?.data?.message || "Upload failed");
      });
  };

  useEffect(() => {
    dispatch(getGenMaster({ tag_id: 11 }));
    dispatch(getProject());
    dispatch(getParty({ is_main: true }));
    dispatch(getItem({ is_main: true }));
    dispatch(getTransport());
  }, []);

  useEffect(() => {
    if (form.party_id && form.project_id) {
      const formData = new URLSearchParams();
      formData.append("tag_number", 10);
      formData.append("party_id", form.party_id);
      formData.append("project_id", form.project_id);
      formData.append("firm_id", localStorage.getItem("PAY_USER_FIRM_ID"));
      formData.append("year_id", localStorage.getItem("PAY_USER_YEAR_ID"));
      dispatch(getPoNo({ formData }));
    }
  }, [form.party_id, form.project_id]);

  const itemData = useSelector(
    (state) => state?.getViewReceiveItems?.user?.data
  );
  useEffect(() => {
    if (data?._id) {
      dispatch(getViewReceiveItems({ formData: { id: data?._id } }));
      setForm({
        trans_date: moment(data?.trans_date).format("YYYY-MM-DD"),
        master_id: data?.received_by?._id,
        project_id: data?.project_data?._id,
        manual_pro_no: data?.manual_pro_no,
        party_id: data?.party_data?._id,
        receive_date: moment(data?.receive_date).format("YYYY-MM-DD"),
        bill_no: data?.bill_no,
        driver_name: data?.driver_name,
        transport_id: data?.transport_data?._id,
        transport_date: moment(data?.transport_date).format("YYYY-MM-DD"),
        lr_no: data?.lr_no,
        lr_date: moment(data?.lr_date).format("YYYY-MM-DD"),
        challan_no: data?.challan_no,
        payment_date: moment(data?.payment_date).format("YYYY-MM-DD"),
        payment_days: data?.payment_days,
        pdf: data?.pdf,
        vehical_no: data?.vehical_no,
        remarks: data?.remarks,
        loading_amount: data?.loading_amount,
        freight_amount: data?.freight_amount,
      });
    } else {
      handleReset();
    }
  }, [data]);

  useEffect(() => {
    if (data?._id) {
      if (itemData?.items_details?.length > 0) {
        setItemsArr(itemData.items_details.map(item => ({ ...item, unit: item?.unit_name, category: item?.category_name, isExisting: true })));
        setItemErrors(itemData.items_details.map(() => ({})));
      } else {
        setItemsArr([{ ...initialItemState }]);
        setItemErrors([{}]);
      }
    } else {
      setItemsArr([{ ...initialItemState }]);
      setItemErrors([{}]);
    }
  }, [itemData, data]);

  useEffect(() => {
    if (data?._id) {
      setTermsCondition(data?.termsCondition);
    }
  }, [data]);

  useEffect(() => {
    const currentItem = itemsArr[itemsArr.length - 1];
    const isValid = !!(currentItem?.item_id && currentItem?.quantity && currentItem?.rate);
    setCanAddMoreItems(isValid || itemsArr.length === 0);
  }, [itemsArr]);

  // Tax Summary Calculation
  useEffect(() => {
    const grossAmount = itemsArr.reduce(
      (sum, item) => sum + (parseFloat(item.amount) || 0),
      0
    );
    const discountAmount = itemsArr.reduce(
      (sum, item) => sum + (parseFloat(item.discount_amount) || 0) + (parseFloat(item.sp_discount_amount) || 0),
      0
    );
    const taxableAmount = itemsArr.reduce(
      (sum, item) => sum + (parseFloat(item.taxable_amount) || 0),
      0
    );
    const taxAmount = itemsArr.reduce(
      (sum, item) => sum + (parseFloat(item.gst_amount) || 0),
      0
    );
    const totalQty = itemsArr.reduce(
      (sum, item) => sum + (parseFloat(item.quantity) || 0),
      0
    );

    const loadingAmount = parseFloat(form.loading_amount) || 0;
    const freightAmount = parseFloat(form.freight_amount) || 0;

    const loadingWithGst = loadingAmount * 1.18;
    const freightWithGst = freightAmount * 1.18;

    const totalBeforeRound = taxableAmount + taxAmount + loadingWithGst + freightWithGst;
    const roundOff = Math.round(totalBeforeRound) - totalBeforeRound;
    const total = Math.round(totalBeforeRound);

    const taxRate = taxableAmount > 0 ? (taxAmount / taxableAmount) * 100 : 0;

    setTaxSummary({
      grossAmount,
      discountAmount,
      taxableAmount,
      subtotal: grossAmount,
      cgst: 0,
      sgst: 0,
      igst: taxAmount,
      taxAmount,
      roundOff,
      total,
      loading_amount: loadingAmount,
      freight_amount: freightAmount,
      taxRate: taxRate,
    });

    setForm((prev) => ({
      ...prev,
      total_amount: total,
      total_quantity: totalQty,
    }));
  }, [itemsArr, form.loading_amount, form.freight_amount]);

  const handleAddItem = () => {
    if (itemsArr.length > 0) {
      const lastItem = itemsArr[itemsArr.length - 1];
      if (!lastItem.item_id || !lastItem.quantity || !lastItem.rate) {
        toast.error("Please complete current item details before adding new item");
        return;
      }
    }
    setItemsArr([...itemsArr, { ...initialItemState }]);
    setItemErrors([...itemErrors, {}]);
  };

  const handleRemoveItem = (index, item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this item?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {

        const itemToDelete = itemsArr[index];

        if (data?._id && itemToDelete?._id) {
          try {
            const payload = {
              id: data._id,
              itemId: itemToDelete._id,
            };
            await axios({
              method: "put",
              url: `${V_URL}/prosafe/pro-delete-pu-item`,
              data: payload,
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization:
                  "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
              },
            });
            dispatch(getViewReceiveItems({ formData: { id: data?._id } }));
            Swal.fire('Deleted!', 'The item has been deleted.', 'success');
          } catch (error) {
            Swal.fire('Error!', error?.response?.data?.message || 'Failed to delete item.', 'error');
            return;
          }
        } else {
          const updatedItems = itemsArr.filter((_, i) => i !== index);
          const updatedItemErrors = itemErrors.filter((_, i) => i !== index);
          setItemsArr(updatedItems.length > 0 ? updatedItems : []);
          setItemErrors(
            updatedItemErrors.length > 0 ? updatedItemErrors : []
          );
        }
      }
    });
  };

  const calculateRowValues = (item) => {
    const qty = parseFloat(item.quantity) || 0;
    const rate = parseFloat(item.rate) || 0;
    const discount = parseFloat(item.discount) || 0;
    const spDiscount = parseFloat(item.sp_discount) || 0;
    const gst = parseFloat(item.gst) || 0;

    const amount = qty * rate;
    const discountAmount = (amount * discount) / 100;
    const afterDiscount = amount - discountAmount;
    const spDiscountAmount = (afterDiscount * spDiscount) / 100;
    const taxableAmount = afterDiscount - spDiscountAmount;
    const gstAmount = (taxableAmount * gst) / 100;
    const totalAmount = taxableAmount + gstAmount;

    return {
      amount: amount.toFixed(2),
      discount_amount: discountAmount.toFixed(2),
      sp_discount_amount: spDiscountAmount.toFixed(2),
      taxable_amount: taxableAmount.toFixed(2),
      gst_amount: gstAmount.toFixed(2),
      total_amount: totalAmount.toFixed(2),
    };
  };

  const handleItemChange = (index, field, value) => {
    const updatedItems = itemsArr.map((item, i) => i === index ? { ...item, [field]: value } : item);

    if (field === "item_id") {
      const selectedItem = itemDataStore.find((it) => it._id === value);
      if (selectedItem) {
        updatedItems[index].item_name = selectedItem.name || "";
        updatedItems[index].unit = selectedItem.unit?.name || "";
        updatedItems[index].category = selectedItem.category?.name || "";
        updatedItems[index].gst = selectedItem.gst_percentage || "0";
      }
    }

    if (field === "item_name") {
      updatedItems[index].item_name = value;
    }

    if (["quantity", "rate", "discount", "sp_discount", "gst"].includes(field)) {
      const calculated = calculateRowValues(updatedItems[index]);
      Object.assign(updatedItems[index], calculated);
    }

    setItemsArr(updatedItems);

    if (error.items && field === "item_id" && value) {
      setError((prev) => {
        const newError = { ...prev };
        delete newError.items;
        return newError;
      });
    }

    if (itemErrors[index] && itemErrors[index][field]) {
      const newErrors = [...itemErrors];
      delete newErrors[index][field];
      setItemErrors(newErrors);
    }
  };

  const handleItemBlur = (index, field) => {
    const item = itemsArr[index];
    const newErrors = [...itemErrors];
    if (!newErrors[index]) newErrors[index] = {};

    if (field === "item_id" && !item.item_id) {
      newErrors[index].item_id = "Item is required";
    } else if (field === "quantity" && (!item.quantity || parseFloat(item.quantity) <= 0)) {
      newErrors[index].quantity = "Quantity is required";
    } else if (field === "rate" && (!item.rate || parseFloat(item.rate) <= 0)) {
      newErrors[index].rate = "Rate is required";
    } else {
      delete newErrors[index][field];
    }
    setItemErrors(newErrors);
  };

  const breadcrumbItems = [
    { label: "Dashboard", link: "/main-store/user/dashboard" },
    {
      label: "Purchase Receive",
      link: "/main-store/user/purchase-receive-management",
    },
    { label: data?._id ? "Edit" : "Add" + " Purchase Receive", active: true },
  ];

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    const checkRequired = (field, message) => {
      if (!form[field]) {
        newErrors[field] = message;
        isValid = false;
      }
    };
    if (!form.trans_date) {
      newErrors.trans_date = "Date is required";
      isValid = false;
    } else {
      const selectedDate = new Date(form.trans_date);
      const currentDate = new Date();
      if (selectedDate > currentDate) {
        newErrors.trans_date = "Date cannot be in the future";
        isValid = false;
      }
    }
    checkRequired("project_id", "Project is required");
    checkRequired("party_id", "Party is required");
    checkRequired("receive_date", "Receiving Date is required");
    checkRequired("master_id", "Received By is required");
    if (!form.bill_no && !form.challan_no) {
      newErrors.bill_no = "Either Bill No. or Challan No. is required";
      newErrors.challan_no = "Either Bill No. or Challan No. is required";
      isValid = false;
    }
    // checkRequired("transport_id", "Transport is required");
    // checkRequired("pdf", "PDF/Image file is required");
    setError(newErrors);
    return isValid;
  };

  const validateItems = () => {
    const hasValidItem = itemsArr.some(item => item.item_id && item.quantity && item.rate);
    if (!hasValidItem) {
      setError(prev => ({ ...prev, items: "At least one item is required" }));
      toast.error("At least one item is required");
      return false;
    }
    return true;
  };

  const handleSave = () => {
    if (!validateForm()) return;
    if (!validateItems()) return;

    setDisable(true);

    const isEdit = !!data?._id;

    const url = isEdit
      ? `${V_URL}/prosafe/pro-update-pu-data`
      : `${V_URL}/prosafe/pro-add-one-pu`;

    const payload = {
      ...(isEdit && { id: data?._id }),

      firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
      year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
      tag_number: 11,

      // termsCondition: termsCondition,

      trans_date:
        form?.trans_date && moment(form.trans_date).isValid()
          ? moment(form.trans_date).format("YYYY-MM-DD")
          : null,

      master_id: form.master_id,
      project_id: form.project_id,
      manual_pro_no: form.manual_pro_no,

      // driver_name: form.driver_name,

      party_id: form.party_id,

      receive_date:
        form?.receive_date && moment(form.receive_date).isValid()
          ? moment(form.receive_date).format("YYYY-MM-DD")
          : null,

      bill_no: form.bill_no,
      challan_no: form.challan_no,

      // transport_id: form.transport_id,
      // transport_date:
      //   form?.transport_date && moment(form.transport_date).isValid()
      //     ? moment(form.transport_date).format("YYYY-MM-DD")
      //     : null,
      // lr_no: form.lr_no,
      // lr_date:
      //   form?.lr_date && moment(form.lr_date).isValid()
      //     ? moment(form.lr_date).format("YYYY-MM-DD")
      //     : null,

      // payment_date:
      //   form?.payment_date && moment(form.payment_date).isValid()
      //     ? moment(form.payment_date).format("YYYY-MM-DD")
      //     : null,
      // payment_days: form.payment_days,

      pdf: form.pdf,

      // vehical_no: form.vehical_no,

      driver_name: form?.driver_name || null,
      remarks: form?.remarks || null,
      loading_amount: form?.loading_amount || null,
      freight_amount: form?.freight_amount || null,

      total_amount: form.total_amount,
      total_quantity: form.total_quantity,

      items_details: JSON.stringify(
        itemsArr.map(({ isExisting, ...rest }) => rest)
      ),
    };

    axios({
      method: isEdit ? "put" : "post",
      url,
      data: payload,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Barrer " + localStorage.getItem("PAY_USER_TOKEN"),
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response?.data?.message);
          navigate("/main-store/user/purchase-receive-management");
        } else {
          toast.error(response?.data?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setDisable(false);
      });
  };

  const handleReset = () => {
    if (data?._id) {
      setForm({
        ...initialForm,
        project_id: data?.project_data?._id,
        party_id: data?.party_data?._id,
      });
      setItemsArr([{ ...initialItemState }]);
      setItemErrors([{}]);
      setTermsCondition(DEFAULT_PO_TERMS || "");
    } else {
      setForm(initialForm);
      setItemsArr([{ ...initialItemState }]);
      setItemErrors([{}]);
      setTermsCondition(DEFAULT_PO_TERMS || "");
    }
    setError({});
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <Breadcrumb items={breadcrumbItems} />

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="col-12">
                      <div className="form-heading">
                        <h4>
                          {data?._id ? "Edit" : "Add"} Purchase Receiving
                          Details
                        </h4>
                      </div>
                    </div>
                    <PurReceiveFields
                      form={form}
                      handleChange={handleChange}
                      handlePdf={handlePdf}
                      error={error}
                      data={data}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* <PurReceiveItems
            itemsArr={itemsArr}
            setItemsArr={setItemsArr}
            form={form}
            data={data}
          /> */}

          <PurReceiveTable
            itemsArr={itemsArr}
            setItemsArr={setItemsArr}
            form={form}
            data={data}
            itemErrors={itemErrors}
            handleItemChange={handleItemChange}
            handleItemBlur={handleItemBlur}
            handleAddItem={handleAddItem}
            handleRemoveItem={handleRemoveItem}
            canAddMoreItems={canAddMoreItems}
            isLoading={disable}
            error={error}
          />

          <TaxSummary
            data={form}
            handleChange={handleChange}
            taxSummary={taxSummary}
            taxType="igst"
            showTerms={false}
          />

          <div className="row mt-4">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="col-12 text-end">
                    <div className="doctor-submit text-end">
                      <button
                        type="button"
                        className="btn btn-primary submit-form me-2"
                        // onClick={data?._id ? handleUpdate : handleSubmit}
                        onClick={handleSave}
                        disabled={disable && !data?._id}
                      >
                        {disable
                          ? "Processing..."
                          : data?._id
                            ? "Update"
                            : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel-form"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ManagePurReceive;
